import React, { useState } from "react";
import Layout from "../Common/Layout";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Stacking = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    companyName: "AgroBuild Pvt. Ltd.",
    date: "2025-11-11",
    pastStock: "17",
    presentStock: "22",
    totalStock: "39",
    totalSpace: "1000",
    occupiedSpace: "780",
    remainingSpace: "220",
  });

  // ✅ Handle input changes
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  // ✅ Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // ✅ Show Toastify success message
    toast.success("✅ Data submitted successfully!", {
      position: "top-right",
      autoClose: 2000,
      theme: "colored",
    });

    // ✅ Redirect after toast delay
    setTimeout(() => {
      navigate("/quality-inbound");
    }, 2500);
  };

  return (
    <>
      <Layout>
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box">
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <a href="javascript:void(0);">IRC Ltd</a>
                        </li>
                        <li className="breadcrumb-item">
                          <a href="javascript:void(0);">Dashboards</a>
                        </li>
                        <li className="breadcrumb-item active">Stacking</li>
                      </ol>
                    </div>
                    <h4 className="page-title">Stacking Management</h4>
                  </div>
                </div>
              </div>

              {/* ===================== FORM START ===================== */}
              <div className="row justify-content-center mt-4">
                <div className="col-xxl-6 col-lg-8 col-md-10">
                  <div className="card shadow-sm border-0 rounded-3">
                    <div className="card-body p-4">
                      <h4 className="card-title mb-4 text-center fw-semibold text-primary">
                        Stacking Report
                      </h4>

                      <form onSubmit={handleSubmit}>
                        {/* Company Name */}
                        <div className="mb-3">
                          <label
                            htmlFor="companyName"
                            className="form-label fw-semibold"
                          >
                            Company Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="companyName"
                            value={formData.companyName}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        {/* Date */}
                        <div className="mb-3">
                          <label htmlFor="date" className="form-label fw-semibold">
                            Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            id="date"
                            value={formData.date}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      <div className="row">
                          <div className="col-md-4 mb-4">
                            {/* Past Stock */}
                        <div className="mb-3">
                          <label htmlFor="pastStock" className="form-label fw-semibold">
                            Past Stock
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="pastStock"
                            value={formData.pastStock}
                            onChange={handleChange}
                            required
                          />
                        </div>
                          </div>
                          <div className="col-md-4 mb-4">
                             {/* Present Stock */}
                        <div className="mb-3">
                          <label
                            htmlFor="presentStock"
                            className="form-label fw-semibold"
                          >
                            Present Stock
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="presentStock"
                            value={formData.presentStock}
                            onChange={handleChange}
                            required
                          />
                        </div>
                          </div>
                          <div className="col-md-4 mb-4">
                              {/* Total Stock */}
                        <div className="mb-3">
                          <label htmlFor="totalStock" className="form-label fw-semibold">
                            Total Stock
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="totalStock"
                            value={formData.totalStock}
                            onChange={handleChange}
                            required
                          />
                        </div>
                          </div>
                      </div>
                        {/* Total Space */}

                        <h4 className="card-title mb-4 text-center fw-semibold text-primary">
                            Storage Report
                         </h4>
                          <div className="row">
                            <div className="col-md-4 mb-4">
                            {/* Total Space */}
                       <div className="mb-3">
                          <label htmlFor="totalSpace" className="form-label fw-semibold">
                            Total Space
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="totalSpace"
                            value={formData.totalSpace}
                            onChange={handleChange}
                            required
                          />
                        </div>
                            </div>
                            <div className="col-md-4 mb-4">
                                    {/* Occupied Space */}
                        <div className="mb-3">
                          <label
                            htmlFor="occupiedSpace"
                            className="form-label fw-semibold"
                          >
                            Occupied Space
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="occupiedSpace"
                            value={formData.occupiedSpace}
                            onChange={handleChange}
                            required
                          />
                        </div>
                            </div>
                            <div className="col-md-4 mb-4">
                                     {/* Remaining Space */}
                        <div className="mb-3">
                          <label
                            htmlFor="remainingSpace"
                            className="form-label fw-semibold"
                          >
                            Remaining Space
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="remainingSpace"
                            value={formData.remainingSpace}
                            onChange={handleChange}
                            required
                          />
                        </div>
                            </div>
                          
                          </div>

                        {/* Submit Button */}
                        <div className="text-center">
                          <button
                            type="submit"
                            className="btn btn-primary px-5 py-2 fw-semibold"
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {/* ===================== FORM END ===================== */}
            </div>
          </div>
        </div>

        {/* Toast Container */}
        <ToastContainer />
      </Layout>
    </>
  );
};

export default Stacking;
